import { api } from './apiClient';

// No sandbox fallbacks here on purpose: consent is a legal record and must
// never be simulated - if the backend is unreachable, the flows just error.

/** Claim-link lookup: { vendorName, alreadyAccepted }. */
export async function getClaimInfo(token) {
  const { data } = await api.get(`/api/vendors/claim/${token}`);
  return data;
}

/** Option 1 - claim-page acceptance (idempotent on the backend). */
export async function acceptClaim(token, { password, confirmMismatch } = {}) {
  const { data } = await api.post(`/api/vendors/claim/${token}/accept`, {
    acceptTerms: true,
    ...(password ? { password } : {}),
    ...(confirmMismatch ? { confirmMismatch: true } : {}),
  });
  return data;
}

/** Option 3 - action-gate acceptance from the terms modal (idempotent). */
export async function acceptVendorTerms() {
  const { data } = await api.post('/api/vendors/me/accept-terms', { acceptTerms: true });
  return data;
}

/**
 * v2 self-serve claim: "Claim this page". Resolves to { emailMasked } when a
 * link was emailed to the address of record, or { needsEmail } when the
 * visitor must submit a claim request instead. The token never reaches the
 * browser - email possession is the ownership proof.
 */
export async function startClaim(vendorId) {
  const { data } = await api.post(`/api/vendors/${vendorId}/claim/start`);
  return data;
}

/** No email on file: queue an unverified request for founder review. */
export async function submitClaimRequest(vendorId, { email, name, proof }) {
  const { data } = await api.post(`/api/vendors/${vendorId}/claim/request`, { email, name, proof });
  return data;
}

/** Directory listings have no account: every claim goes to founder review. */
export async function submitListingClaimRequest(listingId, { email, name, proof }) {
  const { data } = await api.post(`/api/unclaimed/${listingId}/claim-request`, { email, name, proof });
  return data;
}

/** Founder review queue (admin-only endpoints). */
export async function listClaimRequests() {
  const { data } = await api.get('/api/admin/claim-requests');
  return data;
}

export async function approveClaimRequest(vendorId) {
  const { data } = await api.post(`/api/admin/claim-requests/${vendorId}/approve`);
  return data;
}

export async function rejectClaimRequest(vendorId, reason) {
  const { data } = await api.post(`/api/admin/claim-requests/${vendorId}/reject`, { reason });
  return data;
}

export async function approveListingClaimRequest(listingId) {
  const { data } = await api.post(`/api/admin/claim-requests/listings/${listingId}/approve`);
  return data;
}

export async function rejectListingClaimRequest(listingId, reason) {
  const { data } = await api.post(`/api/admin/claim-requests/listings/${listingId}/reject`, { reason });
  return data;
}
